import { render, staticRenderFns } from "./crop.vue?vue&type=template&id=3422c8a2&scoped=true&"
import script from "./crop.vue?vue&type=script&lang=js&"
export * from "./crop.vue?vue&type=script&lang=js&"
import style0 from "./style/crop.css?vue&type=style&index=0&id=3422c8a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3422c8a2",
  null
  
)

export default component.exports